<template>
    <div>
        <headline>
            {{ name }} Buchungen
            <template slot="more">
                <monthspicker @date="load" :date="current" class="mr-2"></monthspicker>

                <button-secondary @click="download">
                    <template slot="icon"><i class="fa fa-download"></i></template> Daten exportieren
                </button-secondary>
            </template>
        </headline>

        <loading v-show="loading"></loading>

        <div class="" v-show="!loading">
            <div>

                <accordion>
                    <accordion-item v-for="(foo, day) in schedules" :key="day" :id="day">
                        <template v-slot:header>
                            <span :class="{'text-primary': asDay(day) === asDay(today) }">{{ asDay(day) }}</span>
                            <span class="font-bold">{{ schedules[day].length }} Buchungen</span>
                        </template>

                        <p class="p-4" v-show="schedules[day].length === 0">
                            Keine Buchungen an diesem Tag gefunden.
                        </p>

                        <tailwind-table :header="['User', 'Name', 'Etage', 'Zeitraum']" v-show="schedules[day] && schedules[day].length > 0">
                            <tr v-for="(schedule, i) in schedules[day]" :class="{'bg-gray-50': i%2}">
                                <td class="px-6 py-3">
                                    <span v-if="schedule.user">{{ schedule.user.first_name }} {{ schedule.user.name }}</span>
                                    <span v-show="schedule.user_id && !schedule.user">gelöschter User</span>
                                    <span v-show="schedule.comment?.length > 0" class="text-gray-500"><br>{{ schedule.comment }}</span>
                                </td>
                                <td class="px-6 py-3">
                                    <span v-if="schedule.bookable.name">{{ schedule.bookable.name }}</span>
                                </td>
                                <td class="px-6 py-3">
                                    <floor-item :item="schedule.bookable.floor"></floor-item>
                                </td>
                                <td class="px-6 py-3">
                                    {{ time(schedule.start) }} - {{ time(schedule.end) }}
                                </td>
                            </tr>
                        </tailwind-table>
                    </accordion-item>
                </accordion>


            </div>

            <p class="p-4" v-show="schedules.length === 0">
                Keine Buchungen in diesem Monat gefunden.
            </p>
        </div>

    </div>
</template>

<script>
import ButtonSecondary from "../components/UI/ButtonSecondary";
import Headline from "../components/UI/Headline";
import Monthspicker from "../components/Monthspicker";
import TailwindTable from "../components/UI/TailwindTable";
import ConfirmDialog from "../components/UI/ConfirmDialog";
import ButtonDelete from "../components/UI/ButtonDelete";
import Loading from "../components/UI/Loading";
import Accordion from "../components/UI/Accordion";
import AccordionItem from "../components/UI/AccordionItem";
import DeskItem from "../components/DeskItem.vue";
import format from "date-fns/format"
import FloorItem from "../components/FloorItem.vue";

export default {
    name: "BookableSchedules",
    components: {
        FloorItem,
        DeskItem,
        AccordionItem,
        Accordion,
        Loading,
        ButtonDelete,
        ConfirmDialog,
        TailwindTable,
        Monthspicker,
        Headline,
        ButtonSecondary,
    },

    props: ['category'],

    data: () => ({
        loading: false,
        current: '',
        schedules: [],
        previous: '',
        next: '',
        name: '',
        today: new Date().toISOString().substring(0, 10),
    }),

    mounted() {
        this.load();
    },

    filters: {
        date(date) {
            const [y, m, d] = date.split('-');

            return d + '.' + m + '.';
        },
    },

    methods: {
        download() {
            window.open('/admin/bookable_schedules/export?month='+this.current);
        },
        load(date = null) {
            let params = {
                category: this.category,
                date: this.date,
          }
            this.loading = true;
            this.$http.get(`/admin/bookable_schedules${date ? '?date=' + date : ''}`, {
               params
               }).then(result => {
                    this.loading = false;
                    this.schedules = result.data.schedules;
                    this.current = result.data.current;
                    this.next = result.data.next;
                    this.previous = result.data.previous;
                    this.name = result.data.bookable.name;
                })
                .catch(error => {
                    this.loading = false;
                    this.$root.$emit('error', error);
                })
        },
        asDay(day) {
            return format(new Date(day), 'dd.MM.');
        },
        time(date) {
            return format(new Date(date), 'dd.MM.') + ' ' + date.slice(11,16)
        }
    },
}
</script>

<style scoped>

</style>
